import { useMemo } from 'react';

import { LinkExternalIcon, LinkRoot } from './Link.styled';

import type { AnchorHTMLAttributes } from 'react';
import type { LinkProps } from './types';

const Link = <RootComponent extends React.ElementType = 'a'>(props: LinkProps<RootComponent>) => {
  const {
    external = false,
    children,
    color = 'default',
    textVariant = 'standalone',
    disabled,
    tabIndex,
    underline: underlineProps,
    ...others
  } = props;

  const anchorAttributes: Pick<
    AnchorHTMLAttributes<HTMLAnchorElement>,
    'target' | 'referrerPolicy' | 'rel'
  > = useMemo(() => {
    if (external)
      return { target: '_blank', referrerPolicy: 'no-referrer', rel: 'noopener noreferrer' };

    return {};
  }, [external]);

  const underline: LinkProps['underline'] = useMemo(() => {
    if (!underlineProps) {
      if (textVariant === 'inline') return 'always';

      return 'none';
    }

    return underlineProps;
  }, [textVariant, underlineProps]);

  return (
    <LinkRoot
      {...others}
      {...anchorAttributes}
      underline={underline}
      textVariant={textVariant}
      color={color}
      disabled={disabled}
      tabIndex={!disabled ? tabIndex : -1}
    >
      {children}
      {external && <LinkExternalIcon />}
    </LinkRoot>
  );
};

export default Link;
